import type { PolymorphicRef } from '@sds-system/types';
import type { ElementType } from 'react';
import { forwardRef } from 'react';
import { Box } from '../Box';
import { Radio } from '../Radio/Radio';
import { StyledRadioGroup } from './RadioGroup.styled';
import type { RadioGroupComponent, RadioGroupProps } from './RadioGroup.types';

export const RadioGroup: RadioGroupComponent = forwardRef(
  <C extends ElementType = 'fieldset'>(
    {
      datas,
      sizeType = 'XS',
      defaultValue,
      name,
      disabled,
      styledComponents,
      value,
      ...props
    }: RadioGroupProps<C>,
    ref: PolymorphicRef<C>,
  ) => {
    return (
      <StyledRadioGroup display='flex' gap={8} ref={ref} {...styledComponents?.root} {...props}>
        {datas.map((data) => (
          <Box alignItems='center' display='flex' gap={8} key={data.value}>
            <Radio
              {...(value && { checked: value === data.value })}
              defaultChecked={defaultValue === data.value}
              disabled={data.disabled || disabled}
              label={data.label}
              name={name}
              sizeType={sizeType}
              styledComponents={styledComponents?.radio}
              value={data.value}
            />
          </Box>
        ))}
      </StyledRadioGroup>
    );
  },
);
